/** 太陽の位置（北緯 46°、7 月中旬）。docs/04_world-and-weather.md 9 章 */
import type { Vec3 } from '../../core/vec';

const LAT = (46 * Math.PI) / 180;
const DECL = (21 * Math.PI) / 180;
/** 南中時刻（夏時間の 13:30 ごろ） */
const SOLAR_NOON_H = 13.5;

export interface SunPosition {
  /** 北 0、時計回り（ラジアン） */
  azimuth: number;
  elevation: number;
  /** 太陽の方向の単位ベクトル（x＝東、y＝上、z＝南） */
  dir: Vec3;
}

export function sunPosition(timeOfDayS: number): SunPosition {
  const H = ((timeOfDayS / 3600 - SOLAR_NOON_H) * 15 * Math.PI) / 180;
  const sinEl = Math.sin(LAT) * Math.sin(DECL) + Math.cos(LAT) * Math.cos(DECL) * Math.cos(H);
  const elevation = Math.asin(sinEl);
  const azFromSouth = Math.atan2(Math.sin(H), Math.cos(H) * Math.sin(LAT) - Math.tan(DECL) * Math.cos(LAT));
  const azimuth = azFromSouth + Math.PI;
  const c = Math.cos(elevation);
  return {
    azimuth,
    elevation,
    dir: { x: Math.sin(azimuth) * c, y: Math.sin(elevation), z: -Math.cos(azimuth) * c },
  };
}
